import request from '@/utils/request'

// 发送验证码
export function sendCode(data) {
  return request({
    url: '/phone/send',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 微信登录
export function wxLogin(data) {
  return request({
    url: '/login/wechat',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 获取微信登录二维码
export function getWxCode(data) {
  return request({
    url: '/wechat/qrcode',
    method: 'get',
    data
  })
}

// 创建微信支付单
export function createWxPay(data) {
  return request({
    url: '/payment/wechat/qrcode',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 查询支付状态
export function queryPayStatus(id) {
  return request({
    url: `/users/orders/${id}`,
    method: 'get',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 获取支付宝支付二维码
export function getAliPayHtml(data) {
  return request({
    url: '/payment/alipay',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 获取用户当前套餐
export function getUserPackage() {
  return request({
    url: '/users/pack',
    method: 'get',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 验证码登录
export function loginByCode(data) {
  return request({
    url: '/login/mobile',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

// 体验套餐
export function tryPackage(data) {
  return request({
    url: '/users/orders/trial',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
